import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-facility-overview',
  templateUrl: './facility-overview.component.html',
  styleUrls: ['./facility-overview.component.scss']
})
export class FacilityOverviewComponent implements OnInit{
  
  @Input() data:any;
  facilityId:string;

  ngOnInit(): void {
    this.facilityId = this.data["facilityId"]
  }
  


}
